export const QUESTION_HOME_INSURANCE_MODULE = 'home_insurance_opt_out'
export const QUESTION_BUYER_ADD_HOME = 'buyer_add_home'
export const QUESTION_INTERESTED_IN_SMS = 'interested_in_sms'
export const QUESTION_INTERESTED_IN_APP = 'interested_in_app'
export const QUESTION_SMS_AND_APP_PREFERENCES = 'sms_and_app_preferences'
export const CONFIRMED_TCA_REQUEST = 'confirmed_tca_request'
export const SNOOZED_AVM_HOT_MARKET = 'snoozed_avm_hot_market'
